import { useSettings } from "../context/SettingsContext";
import { siteImageUrl } from "./SiteImageSetting";

export const pageBgUrl = (settings) => siteImageUrl(settings?.page_bg_path, "/hero_girl.jpg");

export const PageBackdrop = ({ testid = "page-bg" }) => {
    const { settings } = useSettings();
    const BG = pageBgUrl(settings);
    return (
    <div className="fixed inset-0 -z-10 pointer-events-none" aria-hidden data-testid={testid}>
        <div className="absolute inset-0 bg-[#FBF6F0]" />
        <div className="absolute inset-y-0 right-0 w-full md:w-3/5 bg-cover bg-[center_20%]" style={{ backgroundImage: `url(${BG})` }}>
            <div className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-[#FBF6F0] to-transparent" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#FBF6F0] via-[#FBF6F0]/75 to-[#FBF6F0]/0 md:via-[#FBF6F0]/60" />
    </div>
    );
};
